module.exports = __webpack_public_path__ + "img/7.cbd076fe.gif";